import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { usePodcastProvider, PodcastConfig } from "components/podcast/PodcastProvider";
import { useSwipeable } from "react-swipeable";
import { useUrlQueryParams } from "hooks";

//ui
import { Box, Flex, IconButton } from "@chakra-ui/react";
import { ChevronFillIcon, ChevronLeftIcon, ChevronRightIcon } from "components/icons";
import { AudioModalContent } from "./AudioModalContent";
import { VideoModalContent } from "./VideoModalContent";

export function EpisodeDetailsModalContent() {
  const history = useHistory();
  const location = useLocation();
  const query = useUrlQueryParams();

  const { onClose, playingPodcast, podcastData, setPlayingPodcast, setPlayPodcast, setModalType } = usePodcastProvider();
  const [previousPodcast, setPreviousPodcast] = useState<PodcastConfig | null>(null);
  const [nextPodcast, setNextPodcast] = useState<PodcastConfig | null>(null);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (previousPodcast) setPlayingPodcast(previousPodcast);
    },
    onSwipedRight: () => {
      if (nextPodcast) setPlayingPodcast(nextPodcast);
    }
  });

  useEffect(() => {
    const playingPodcastId = playingPodcast?.episode_number ?? 0;
    const previous = podcastData.slice(1).filter(podcast => podcast.episode_number === playingPodcastId - 1);
    setPreviousPodcast(previous[0]);
    const next = podcastData.slice(1).filter(podcast => podcast.episode_number === playingPodcastId + 1);
    setNextPodcast(next[0]);
  }, [playingPodcast, podcastData]);

  const handleClose = () => {
    const currentEpisodeNumber = Number(query.get("episode_number"));
    if (currentEpisodeNumber) {
      if (currentEpisodeNumber) {
        history.replace({ pathname: location.pathname });
      }
    }
    onClose();
    if (playingPodcast?.video_urls) {
      setPlayingPodcast(null);
      setPlayPodcast(false);
      setModalType(null);
    }
  };

  return (
    <Flex flexDir="column" pt="12px" color="purple.50" width="100%" alignItems={{ base: "flex-start", md: "center" }} {...handlers}>
      <IconButton
        icon={<ChevronFillIcon width="48px" height="48px" />}
        width="24px"
        aria-label="close-modal"
        bg="transparent"
        borderRadius="24px"
        _hover={{ bg: "transparent" }}
        color="purple.50"
        onClick={handleClose}
        display={{ base: "flex", md: "none" }}
        ml="8px"
      />
      <Flex pt="24px" pb={{ base: "73px", md: "48px" }} color="purple.50" width="100%" alignItems="center" justifyContent="space-between">
        <Box width="84px" display={{ base: "none", md: "flex" }}>
          {previousPodcast && (
            <IconButton
              icon={<ChevronLeftIcon width="16px" height="31px" />}
              width="84px"
              height="96px"
              aria-label="previous-podcast"
              bg="transparent"
              borderRadius="24px"
              _hover={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              color="purple.50"
              onClick={() => setPlayingPodcast(previousPodcast)}
            />
          )}
        </Box>
        {playingPodcast?.audio_urls ? <AudioModalContent /> : <VideoModalContent />}
        <Box width="84px" display={{ base: "none", md: "flex" }}>
          {nextPodcast && (
            <IconButton
              icon={<ChevronRightIcon width="16px" height="31px" />}
              width="96px"
              height="96px"
              aria-label="next-podcast"
              bg="transparent"
              borderRadius="24px"
              _hover={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              color="purple.50"
              display={{ base: "none", md: "flex" }}
              onClick={() => setPlayingPodcast(nextPodcast)}
            />
          )}
        </Box>
      </Flex>
    </Flex>
  );
}
